import React, { useEffect, useState } from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Input,
  Button,
} from "reactstrap"

import { useNavigate, useParams } from "react-router-dom"
import * as Yup from "yup"

import { interestFrequency, repaymentSchedule } from "helpers/utils"
import {
  formatAmount,
  getDateOfRepayment,
  getFundRequirementDate,
  getIcdRequestStatus,
} from "helpers/common"
import toast from "react-hot-toast"
import LoaderComponent from "components/loader"
import RejectConfirmationModal from "./confirm/rejectConfirmation"
import ApproveConfirmationModal from "./confirm/approveConfirmation"
import ICDAgreementBox from "pages/Dashboard/icdAgreementBox"
import PaymentUtrModel from "modals/paymentUTRModel"
import { useFormik } from "formik"
// import IcdPaymentBox from "./icdPaymentBox"
import { usePermission } from "hooks/usePermission"
import SignAgreementModal from "pages/InvestorPages/signAgreementModal"
import {
  useApproveOfferWpMutation,
  useIcdPaymentWpMutation,
  useLazyViewIcdRequestWpQuery,
  useRejectOfferWpMutation,
} from "store/api/wealthpartnerapi/wpicds.api"

const ViewICDRequestsWp = () => {
  //meta title
  document.title = "ICD Request | Prachay"

  const { id } = useParams()
  const navigate = useNavigate()
  const [icdData, setIcdData] = useState(null)

  const [getDetails, { isFetching }] = useLazyViewIcdRequestWpQuery()
  const [makePayment, { isLoading }] = useIcdPaymentWpMutation()

  const [isToast, setIsToast] = useState(false)
  const [actionType, setActionType] = useState() //APPROVE,REJECT

  const [onApprove, { isLoading: isApproving }] = useApproveOfferWpMutation()
  const [onReject, { isLoading: isRejecting }] = useRejectOfferWpMutation()

  const [open, setOpen] = useState(false)
  const [isPayment, setIsPayment] = useState(false)
  const [signingRequestOpen, setSigningRequestOpen] = useState(false)

  const onGetDetails = async () => {
    try {
      const { data } = await getDetails({ id }).unwrap()
      setIcdData(data)
    } catch (error) {
      if (error.status === 404) {
        navigate("/investment-management/fund-requests")
      }
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  useEffect(() => {
    if (icdData && icdData?.status === "TERM_SHEET_SHARED") setOpen(true)
  }, [icdData])

  const handlePayment = async (values) => {
    try {
      const { data, success, message } = await makePayment({
        icdId: icdData?.id,
        ...values,
        returnUrl: window.location.href,
      }).unwrap()
      if (success) {
        toast.success(message, { id: "toastMessage" })
        window.location.reload()
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        paymentValidation.setErrors(errors)
      }
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  const paymentValidation = useFormik({
    enableReinitialize: true,
    initialValues: { itr: "", amount: "" },
    validationSchema: Yup.object({}),
    onSubmit: async (values) => {
      await handlePayment({ ...values, paymentType: "OFFLINE" })
    },
  })

  useEffect(() => {
    if (id) {
      onGetDetails()
    }
  }, [id])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {isFetching ? (
            <LoaderComponent />
          ) : (
            <Row className="mt-4">
              <Col xl={12}>
                <Card>
                  <CardBody className="pt-4">
                    <div className="d-flex align-items-center mb-4 justify-content-between ">
                      <CardTitle className="heading-badge">
                        <span> ICD Request ( {icdData?.unique_code} )</span>
                      </CardTitle>

                      {!isFetching && icdData && (
                        <>
                          <div className="code-status">
                            {getIcdRequestStatus(icdData.status)}
                          </div>
                        </>
                      )}
                    </div>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Investor Name
                        </Label>
                        <Input
                          disabled
                          name="Name "
                          type="text"
                          className="form-control"
                          id="horizontal-email-id "
                          placeholder="Investor Name"
                          value={icdData?.investor?.name}
                        />
                      </Col>
                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Email Address
                        </Label>
                        <Input
                          disabled
                          name="Name "
                          type="text"
                          className="form-control"
                          id="horizontal-email-id "
                          placeholder="Email Address"
                          value={icdData?.investor?.email}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Mobile
                        </Label>
                        <Input
                          disabled
                          name="Name "
                          type="text"
                          className="form-control"
                          id="horizontal-email-id "
                          placeholder="Phone No."
                          value={icdData?.investor?.phone}
                        />
                      </Col>
                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          PAN
                        </Label>
                        <Input
                          disabled
                          name="Name "
                          type="text"
                          className="form-control"
                          id="horizontal-email-id "
                          placeholder="PAN"
                          value={icdData?.investor?.pan_no}
                        />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              <Col xl={12}>
                <Card>
                  <CardBody className="pt-4">
                    <CardTitle className="mb-4">ICD Details</CardTitle>
                    <Row className="mb-2">
                      <Col xl={12}>
                        <Row className="mb-2">
                          <Col xl={12}>
                            <Row className="mb-2">
                              <Col xl={6}>
                                <Label className="col-form-label">
                                  Investment Amount
                                </Label>
                                <Input
                                  disabled
                                  type="text"
                                  className="form-control"
                                  id="horizontal-firstname-Input"
                                  placeholder="Investment Amount"
                                  value={`₹ ${formatAmount(icdData?.countered ? icdData?.icds?.amount : icdData?.amount)}`}
                                />
                              </Col>
                              <Col xl={6}>
                                <Label className="col-form-label">
                                  Date of Repayment
                                </Label>
                                <Input
                                  disabled
                                  type="text"
                                  className="form-control"
                                  id="horizontal-email-id "
                                  placeholder="Date of Repayment"
                                  value={getDateOfRepayment(
                                    icdData?.icds?.repayment_date
                                  )}
                                />
                              </Col>
                            </Row>
                            <Row className="mb-2">
                              <Col xl={6}>
                                <Label className="col-form-label">
                                  Tenure(in days)
                                </Label>
                                <Input
                                  disabled
                                  type="text"
                                  className="form-control"
                                  placeholder="Tenure"
                                  value={icdData?.icds?.tenure}
                                />
                              </Col>
                              <Col xl={6}>
                                <Label className="col-form-label">
                                  Interest Rate (%)
                                </Label>
                                <Input
                                  disabled
                                  type="text"
                                  className="form-control"
                                  placeholder="Interest Rate"
                                  value={icdData?.icds?.interest_rate}
                                />
                              </Col>

                              <Col xl={6}>
                                <Label className="col-form-label">
                                  Interest Payment Frequency
                                </Label>
                                <Input
                                  disabled
                                  type="text"
                                  className="form-control"
                                  placeholder="Interest Rate"
                                  value={
                                    icdData &&
                                    interestFrequency.find(
                                      (item) =>
                                        item.key ===
                                        icdData?.icds?.interest_frequency
                                    ).label
                                  }
                                />
                              </Col>

                              <Col xl={6}>
                                <Label className="col-form-label">
                                  {icdData?.created_by === "ADMIN"
                                    ? "Fund Requirement Date"
                                    : "Fund Availability Date"}
                                </Label>
                                <Input
                                  disabled
                                  type="text"
                                  className="form-control"
                                  id="horizontal-email-id "
                                  placeholder="Fund Availability Date"
                                  value={getFundRequirementDate(
                                    icdData?.icds?.fund_requirement_date
                                  )}
                                />
                              </Col>
                              <Col xl={6}>
                                <Label className="col-form-label">
                                  Repayment Schedule
                                </Label>
                                <Input
                                  disabled
                                  type="text"
                                  className="form-control"
                                  id="horizontal-email-id "
                                  placeholder="Fund Requirement Date"
                                  value={
                                    icdData &&
                                    repaymentSchedule.find(
                                      (item) =>
                                        item.key ===
                                        icdData?.icds?.repayment_schedule
                                    ).label
                                  }
                                />
                              </Col>
                              {icdData?.icds?.repayment_schedule ===
                                "MULTIPLE" && (
                                <Col xl={6}>
                                  <Label className="col-form-label">
                                    No. Of Installments
                                  </Label>
                                  <Input
                                    name="repayment_terms"
                                    type="number"
                                    disabled
                                    className="form-control"
                                    id="repayment_terms"
                                    placeholder="Total Installments"
                                    value={icdData.icds?.repayment_terms}
                                  />
                                </Col>
                              )}
                            </Row>
                          </Col>
                        </Row>

                        {icdData?.countered && (
                          <>
                            <Row className="mb-2">
                              <CardTitle className="my-4">
                                Counter Offer
                              </CardTitle>
                            </Row>

                            <Row className="mb-2">
                              <Col xl={6}>
                                <Label className="col-form-label">
                                  Investment Amount
                                </Label>
                                <Input
                                  disabled
                                  type="text"
                                  className="form-control"
                                  id="horizontal-firstname-Input"
                                  placeholder="Investment Amount"
                                  value={`₹ ${formatAmount(icdData?.amount)}`}
                                />
                              </Col>
                              <Col xl={6}>
                                <Label className="col-form-label">
                                  Date of Repayment
                                </Label>
                                <Input
                                  disabled
                                  type="text"
                                  className="form-control"
                                  id="horizontal-email-id "
                                  placeholder="Date of Repayment"
                                  value={getDateOfRepayment(
                                    icdData?.repayment_date
                                  )}
                                />
                              </Col>
                            </Row>
                            <Row className="mb-2">
                              <Col xl={6}>
                                <Label className="col-form-label">
                                  Tenure(in days)
                                </Label>
                                <Input
                                  disabled
                                  type="text"
                                  className="form-control"
                                  placeholder="Tenure"
                                  value={icdData?.tenure}
                                />
                              </Col>
                              <Col xl={6}>
                                <Label className="col-form-label">
                                  Interest Rate (%)
                                </Label>
                                <Input
                                  disabled
                                  type="text"
                                  className="form-control"
                                  placeholder="Interest Rate"
                                  value={icdData?.interest_rate}
                                />
                              </Col>

                              <Col xl={6}>
                                <Label className="col-form-label">
                                  Interest Payment Frequency
                                </Label>
                                <Input
                                  disabled
                                  type="text"
                                  className="form-control"
                                  placeholder="Interest Rate"
                                  value={
                                    icdData &&
                                    interestFrequency.find(
                                      (item) =>
                                        item.key === icdData?.interest_frequency
                                    ).label
                                  }
                                />
                              </Col>

                              <Col xl={6}>
                                <Label className="col-form-label">
                                  Fund Availability Date
                                </Label>
                                <Input
                                  disabled
                                  type="text"
                                  className="form-control"
                                  id="horizontal-email-id "
                                  placeholder="Fund Availability Date"
                                  value={
                                    icdData &&
                                    getFundRequirementDate(
                                      icdData.fund_requirement_date
                                    )
                                  }
                                />
                              </Col>
                              <Col xl={6}>
                                <Label className="col-form-label">
                                  Repayment Schedule
                                </Label>
                                <Input
                                  disabled
                                  type="text"
                                  className="form-control"
                                  id="horizontal-email-id "
                                  placeholder="Fund Requirement Date"
                                  value={
                                    icdData &&
                                    repaymentSchedule.find(
                                      (item) =>
                                        item.key === icdData?.repayment_schedule
                                    ).label
                                  }
                                />
                              </Col>
                              {icdData?.repayment_schedule === "MULTIPLE" && (
                                <Col xl={6}>
                                  <Label className="col-form-label">
                                    No. Of Installments
                                  </Label>
                                  <Input
                                    name="repayment_terms"
                                    type="number"
                                    disabled
                                    className="form-control"
                                    id="repayment_terms"
                                    placeholder="Total Installments"
                                    value={icdData?.repayment_terms}
                                  />
                                </Col>
                              )}

                              <Col xl={6}>
                                <Label className="col-form-label">
                                  Lock-in (in days)
                                </Label>
                                <Input
                                  name="lockin_period"
                                  type="number"
                                  disabled
                                  className="form-control"
                                  id="lockin_period"
                                  placeholder="Days"
                                  value={icdData?.lockin_period}
                                />
                              </Col>
                              <Col xl={6}>
                                <Label className="col-form-label">
                                  Notice Period (in days)
                                </Label>
                                <Input
                                  name="lockin_period"
                                  type="number"
                                  disabled
                                  className="form-control"
                                  id="lockin_period"
                                  placeholder="Days"
                                  value={icdData?.notice_period}
                                />
                              </Col>
                            </Row>
                            {icdData?.comments && (
                              <Row className="mb-2">
                                <Col xl={12}>
                                  <Label
                                    htmlFor="horizontal-firstname-Input"
                                    className="col-form-label"
                                  >
                                    Comments / Notes
                                  </Label>
                                  <Input
                                    disabled
                                    name="Name "
                                    type="textarea"
                                    className="form-control textarea"
                                    id="horizontal-email-id "
                                    placeholder="Comment"
                                    value={icdData?.comments}
                                  />
                                </Col>
                              </Row>
                            )}
                          </>
                        )}
                      </Col>
                    </Row>
                    {icdData?.status === "TERM_SHEET_FINALISED" && (
                      <>
                        <Row className="justify-content-end mt-4">
                          <Col sm={12}>
                            <div className="d-flex justify-content-end align-items-center gap-3">
                              <button
                                onClick={() => {
                                  setIsPayment(true)
                                  paymentValidation.setFieldValue(
                                    "amount",
                                    icdData?.amount -
                                      (icdData?.investorsPayments?.reduce(
                                        (sum, item) => sum + (item.amount || 0),
                                        0
                                      ) || 0)
                                  )
                                }}
                                type="button"
                                className="btn btn-cancel w-md"
                              >
                                Offline Payment
                              </button>
                            </div>
                          </Col>
                        </Row>
                        <PaymentUtrModel
                          icd={icdData}
                          open={isPayment}
                          setOpen={setIsPayment}
                          validation={paymentValidation}
                          isLoading={isLoading}
                        />
                      </>
                    )}
                    {icdData?.created_by === "ADMIN" &&
                      icdData?.status === "COUNTER_OFFER" && (
                        <>
                          <Row>
                            <Col xl={12}>
                              <div className="buttons">
                                <Button
                                  className="reject"
                                  onClick={() => {
                                    setIsToast(true)
                                    setActionType("REJECT")
                                  }}
                                >
                                  Reject
                                </Button>
                                <Button
                                  className="approve"
                                  onClick={() => {
                                    setIsToast(true)
                                    setActionType("APPROVE")
                                  }}
                                >
                                  Approve
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        </>
                      )}
                    <ICDAgreementBox
                      open={open}
                      setOpen={setOpen}
                      template_type="TERM_SHEET"
                      icd_id={icdData?.id}
                    />
                    {icdData && isToast && actionType === "APPROVE" && (
                      <ApproveConfirmationModal
                        open={isToast}
                        id={id}
                        icdData={icdData}
                        setOpen={setIsToast}
                        isLoading={isApproving}
                        onClose={() => {
                          setIsToast(false)
                          setActionType("")
                        }}
                        onApprove={onApprove}
                        onSuccess={() => {
                          onGetDetails()
                          setIsToast(false)
                        }}
                        setSigningRequestOpen={setSigningRequestOpen}
                      />
                    )}
                    {icdData && isToast && actionType === "REJECT" && (
                      <RejectConfirmationModal
                        open={isToast}
                        id={id}
                        setOpen={setIsToast}
                        isLoading={isRejecting}
                        onClose={() => {
                          setIsToast(false)
                          setActionType("")
                        }}
                        onReject={onReject}
                        onSuccess={() => {
                          onGetDetails()
                          setIsToast(false)
                        }}
                      />
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
        </Container>
      </div>

      <SignAgreementModal
        open={signingRequestOpen}
        setOpen={setSigningRequestOpen}
        showAlert={true}
        assignedInvestors={true}
      />
    </React.Fragment>
  )
}

export default ViewICDRequestsWp
